import { render, staticRenderFns } from "./impressaoComponent.vue?vue&type=template&id=a610d756"
import script from "./impressaoComponent.ts?vue&type=script&lang=js&external"
export * from "./impressaoComponent.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a610d756')) {
      api.createRecord('a610d756', component.options)
    } else {
      api.reload('a610d756', component.options)
    }
    module.hot.accept("./impressaoComponent.vue?vue&type=template&id=a610d756", function () {
      api.rerender('a610d756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/impressao/impressaoComponent.vue"
export default component.exports